import { ConvertToJSONService } from './convert-to-json.service';
import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable, firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { EncrdecrService } from './../Auth/encrdecr.service';
const headers = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
  })
};


@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  ServerUrl = environment.ServerUrl;

  constructor(private http: HttpClient,
    private EncrdecrService: EncrdecrService,
    private ConvertToJSON: ConvertToJSONService) {


  }


  GetDashboardDetail(subbrokerId: string, subbrokerCode: string): Observable<any[]> {
    //////////
    let url = `${this.ServerUrl}/api/BusinessDashboard/Details?SB_ID=${this.EncrdecrService.setEncr(subbrokerId)}&SUBBROKERCODE=${this.EncrdecrService.setEncr(subbrokerCode)}`;
    //console.log('Dashboard => '+url)
    const header = this.GetToken();
    const json = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1]);
    return this.http.post<any[]>(url.split('?')[0], json, header).pipe();
  }
  async GetClientDashboardDetail(clientId: number): Promise<Observable<any>> {

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    console.log(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    let url = `/api/BusinessDashboard/GetDetailsIIFL`;
    let QueryString = `ClientBasicInfoId=${clientId}`;

    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    // return this.http.post<any[]>(url, body, tokenOption).pipe();
    const result = await this.postAPICall(body, url,this.GetToken());
    return result;
  }

  GetFamilyDashboardDetail(familyId: number): Observable<any[]> {
    //
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    let url = `${this.ServerUrl}/api/BusinessDashboard/Details`;
    const QueryString = `FAMILY_ID=${this.EncrdecrService.setEncr(familyId.toString())}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    return this.http.post<any[]>(url, body, tokenOption).pipe();
  }

  GetFamilyGroupDetail(familyGroupId: number): Observable<any[]> {
    ////////
    // familyGroupId = 1148;
    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    let url = `${this.ServerUrl}/api/ClientFamilyGroup/ClientFamilyGroupDetails`;
    const QueryString = `TRANS_TYPE=&REFF_ID=${familyGroupId}`;
    const body = this.ConvertToJSON.QueryStringToJSON(QueryString);
    //console.log(url);
    return this.http.post<any[]>(url, body, tokenOption).pipe();
  }
  getAIFDashboardData(subbrokerId: string, subbrokerCode: string, UserType: string): Observable<any[]> {
    // tslint:disable-next-line: max-line-length
    const url = `${this.ServerUrl}/api/UserDashBoardAIF?LOGIN_ID=${subbrokerId}&Role_ID=0&USER_TYPE=${UserType}&SUB_BROKER_CODE=${subbrokerCode}`;
    console.log(url);
    return this.http.post<any[]>(url, '').pipe();
  }

  getDEDashboardData(subbrokerId: string, subbrokerCode: string, UserType: string): Observable<any[]> {
    // tslint:disable-next-line: max-line-length
    const url = `${this.ServerUrl}/api/UserDashBoardDE/Details?LOGIN_ID=${subbrokerId}&Role_ID=0&USER_TYPE=${UserType}&SUB_BROKER_CODE=${subbrokerCode}`;
    return this.http.post<any[]>(url, '').pipe();
  }

  getPMSDashboardData(subbrokerId: string, subbrokerCode: string, UserType: string): Observable<any[]> {
    // tslint:disable-next-line: max-line-length
    const url = `${this.ServerUrl}/api/UserDashBoardPMS?LOGIN_ID=${subbrokerId}&Role_ID=0&USER_TYPE=${UserType}&SUB_BROKER_CODE=${subbrokerCode}`;
    // const url = `http://173.249.23.172:9099/api/UserDashBoardPMS?LOGIN_ID=1608&Role_ID=1&USER_TYPE=1`;
    return this.http.post<any[]>(url, '').pipe();
  }
  getCPDashboardData(subbrokerId: string, subbrokerCode: string, UserType: string): Observable<any[]> {
    // tslint:disable-next-line: max-line-length
    const url = `${this.ServerUrl}/api/UserDashBoardPMS?LOGIN_ID=${subbrokerId}&Role_ID=0&USER_TYPE=${UserType}&SUB_BROKER_CODE=${subbrokerCode}`;
    // const url = `${this.ServerUrl}/api/BirlaSubbrokerLandingDashBoard?USER_ID=00006220&LOGIN_ID=3001&RoleID=0&USER_TYPE=2`;
    const header = this.GetToken();
    const json = this.ConvertToJSON.QueryStringToJSON(url.split('?')[1]);
    return this.http.post<any[]>(url.split('?')[0], json, header).pipe();
  }
  NetBanking(body): Observable<any> {
    //const header = this.GetToken();
    const url = `${this.ServerUrl}/api/NetBanking/CheckClient?${body}`;
    return this.http.get<any>(url).pipe();
  }
  GetToken() {

    let token = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    let UserId = this.EncrdecrService.getDecr(sessionStorage.getItem('m5JkoXISmYRAIuY'));
    let UserType = this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'));
    let IpAddress = sessionStorage.getItem('Tgsh@#3734fjfskshh==');
    const TOKEN = btoa(token + "@" + UserId + "|" + UserType + "|" + IpAddress);
    const tokenOption = {
      headers:
        new HttpHeaders(
          {
            'Content-Type': 'application/json',
            'Authorization': `Basic ${TOKEN}`,
          })
    }
    return tokenOption;
  }

  GetTopFund(Flag: string): Observable<any[]> {
    let DataUrl = `${this.ServerUrl}/api/Top2SchemeList/Details?ExChangeFlag=${Flag}`;
    const url = DataUrl.split('?')[0];
    const QueryString = DataUrl.split('?')[1];
    const body = this.ConvertToJSON.QueryStringToJSONWithEncryptedValue(QueryString);
    return this.http.post<any[]>(url,body).pipe();
  }

  getLatestBlogPostData(Flag: string) {
    let url = `${this.ServerUrl}/api/blog/Details?Flag=${Flag}`;
    return this.http.get<any[]>(url).pipe();
  }

  getTopPerformingMFData(Flag: string) {
    let url = `${this.ServerUrl}/api/Top2SchemeList/GetTop5SchemeList?ExChangeFlag=${Flag}`;
    return this.http.get<any[]>(url).pipe();
  }

  async postAPICall(Request: any, URL: any,headersdy = {}): Promise<any> {
    let Url = `${this.ServerUrl}${URL}`;
    // let Url = `http://localhost:2010/${URL}`;

    let KeyPair = await this.EncrdecrService.getKeyPair();
    Request.publicKey = KeyPair.publicKeySpkiBase64;

    let EncryptedData = await this.EncrdecrService.encryptJson(Request, environment.RSA_PUBLIC_KEY_BASE64);

    let body = {
      "EncryptedData": EncryptedData.encryptedData,
      "dvfv": EncryptedData.encryptedKey,
      "sdcsd": EncryptedData.iv
    };
    if(!headersdy){
      headersdy = headers
    }
    const response = await firstValueFrom(this.http.post<any>(Url, body, headersdy));

    const DecryptedResponse = this.EncrdecrService.decryptResponse(
      response.EncryptedDataBase64,
      response.EncryptedAesKeyBase64,
      response.IvBase64,
      KeyPair.privateKeyPem
    );

    return DecryptedResponse;
  }
}
